export function installMobileZoomGuard() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return;
  if (window.__mbvMobileZoomGuardInstalled) return;
  window.__mbvMobileZoomGuardInstalled = true;

  let lastTouchEnd = 0;

  const preventMultiTouch = (event) => {
    if (event.touches?.length > 1) {
      event.preventDefault();
    }
  };

  const preventDoubleTapZoom = (event) => {
    const now = Date.now();
    if (now - lastTouchEnd <= 300) {
      event.preventDefault();
    }
    lastTouchEnd = now;
  };

  document.addEventListener('touchstart', preventMultiTouch, { passive: false });
  document.addEventListener('touchend', preventDoubleTapZoom, { passive: false });

  ['gesturestart', 'gesturechange', 'gestureend'].forEach((eventName) => {
    document.addEventListener(
      eventName,
      (event) => {
        event.preventDefault();
      },
      { passive: false }
    );
  });
}
